import { render, staticRenderFns } from "./CountByApplyDocResearcherOrgComponent.vue?vue&type=template&id=4a3f5009&scoped=true&"
import script from "./CountByApplyDocResearcherOrgComponent.vue?vue&type=script&lang=js&"
export * from "./CountByApplyDocResearcherOrgComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3f5009",
  null
  
)

export default component.exports